$('.redirect-link').on('click', function() {
    if ($(this).attr('data-link')) {
        var dataLink = $(this).attr('data-link');
        var baseUrl = window.location.hostname;
        var protocol = document.location.protocol;
        document.location.replace(protocol + "//" + baseUrl + dataLink);
    }   
});